import { tabConfigMap } from "./mappings/tabConfigMapping"

export function getMappedTabConfigData(response, tournamentId) {
    console.log(response)

    let tabConfig = response.find(tabItem => {
        return tabItem.tounament_id == tournamentId
    })

    let tabConfigData = tabConfig.tabs.map(tabItem => {
        return {
            widgetDisplayName: tabItem?.label,
            widgetName: tabConfigMap[tabItem["name"]]?.widgetName,
            sl: tabItem?.sl
        }
    }).sort((a, b) => a.sl - b.sl);

    return tabConfigData;
}

export function downloadObjectAsJson(exportObj, exportName){
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
}